import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function HedgesContractsStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_HEDGES_CONTRACTS_STEP_ID}
            itemTypeIds={[mappedItemTypes.PHYSICAL_INSTRUMENT.id, mappedItemTypes.FINANCIAL_INSTRUMENT.id]}
        />
    );
}
